import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/forgot-password/index.js");
